import React, { useMemo } from "react";

import { Theme, useTheme } from "@mui/material/styles";

import { InvoiceItemViewProps, ShippingCartType } from "./ShippingCart.types";
import {
  RowContainer,
  formatDate,
  formatLocalizedMoney,
  logDebug,
  mergeProperties,
} from "packable-components";
import { Divider, Grid, Typography } from "@mui/material";

import "./ShippingCart.css";

const getStyles = (theme: Theme) => ({
  InvoiceItemViewContainer: {
    width: "100%",
    pb: 2,
  },
  InvoiceItemViewContainerDivider: {
    mb: 2,
  },
  InvoiceItemViewContentActionRow: {
    padding: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  InvoiceItemViewContentActionRemoveButton: {
    muiVariant: "contained",
    muiColor: "secondary",
  },
});

export const InvoiceItemView: React.FC<InvoiceItemViewProps> = (
  props
): React.JSX.Element => {
  const { shippingCartType, shippingCartItemPrice, styles } =
    props;

  logDebug("InvoiceItemView PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useMemo(() => getStyles(theme), [theme]);
  const effectiveStyles = useMemo(
    () =>
      styles === undefined
        ? defaultStyles
        : mergeProperties(defaultStyles, styles),
    [defaultStyles, styles]
  );

  logDebug("InvoiceItemView effectiveStyles");
  logDebug(effectiveStyles);

  const getItemLabel = (): string => {
    if (shippingCartType === ShippingCartType.STORAGE) {
      return `${
        shippingCartItemPrice.itemLabel
      } store until ${formatDate(
        new Date(shippingCartItemPrice.storageEndDate).toDateString(),
        Intl.DateTimeFormat().resolvedOptions().locale, 
        { dateStyle: "short" }
      )}`;
    }
    return shippingCartItemPrice.itemLabel;
  };

  return (
    <Grid
      className="InvoiceItemViewContainer"
      sx={effectiveStyles.InvoiceItemViewContainer}
    >
      <Divider
        className="InvoiceItemViewContainerDivider"
        sx={effectiveStyles.InvoiceItemViewContainerDivider}
      />
      <RowContainer>
        <Grid sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography variant="body1">{getItemLabel()}</Typography>
          <Typography variant="body2">
            {`Item Sub-Total: ${formatLocalizedMoney(
              shippingCartItemPrice.subTotal,
              2,
              shippingCartItemPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography variant="body2">
            {`Tax: ${formatLocalizedMoney(
              shippingCartItemPrice.tax,
              2,
              shippingCartItemPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography variant="body2">
            {`Item Total: ${formatLocalizedMoney(
              shippingCartItemPrice.total,
              2,
              shippingCartItemPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
        </Grid>
      </RowContainer>
    </Grid>
  );
};
